/**
 * Layers of constraints' visual clues in the grid's SVG - see the `Field` component for usage.
 */
export enum GridLayer {
    beforeBackground,
    beforeSelection,
    regular,
    lines,
    afterLines,
    givenUserLines,
    newUserLines,
    top,
    noClip,
    noClipTop,
    interactive,
}
